import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  label: {
    marginBottom: '6px',
    color: '#071B27',
    textTransform: 'uppercase',
    fontSize: '10px',
    lineHeight: '12px',
    letterSpacing: '0.035em'
  },
  inputRoot: {
    borderRadius: '3px',
    border: '1px solid #BECEDA',
    '&:hover': {
      border: `1px solid ${theme.baseUI.color}`
    }
  },
  inputCheckbox: {
    width: '40px',
    paddingBottom: '13px'
  },
  inputRootFocused: {
    boxShadow: `0 0 3px 0.5px ${theme.baseUI.color}`,
    border: `1px solid ${theme.baseUI.color}`
  },
  error: {
    boxShadow: 'none',
    border: '1px solid #EB5757',
    '&:hover': {
      border: '1px solid #EB5757'
    }
  },
  input: {
    padding: '9px 10px',
    fontSize: '13px',
    lineHeight: '18px'
  },
  disabledInput: {
    backgroundColor: '#e2ebf6',
    color: '#59758b'
  },
  disabledLabel: {
    color: '#071B27 !important'
  }
}));
